import api from '@app/utils/api';

export const fetchUserByUUID = (token) => {
  return api.post(
    `/validate-invite-link`,
    {token},
    {
      notIncludeToken: true,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const createUser = (body, token) => {
  return api.post(`/executive/register`, body, {
    notIncludeToken: true,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const createCorporate = (body, token) => {
  return api.post('/executive/corporate/register', body, {
    notIncludeToken: true,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
